import { Injectable, isDevMode } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Product, CategoriesTree, Category, Characteristic, Filter, FileDetails, FileProduct, InfoExt, InfoExt_Celler } from '../_models';
import { Observable,  of, throwError, iif } from 'rxjs';
import { retryWhen,  map,  delay,  concatMap,  catchError, finalize, mergeMap, switchMap, switchMapTo, withLatestFrom, share, tap} from 'rxjs/operators';
import { UtilsService } from './utils.service';
import { environment } from 'src/environments/environment.prod';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class CatalogService {

    public searching : boolean = false;
    public loading : boolean = false;
        
    public Tree : CategoriesTree = null;
    public cachedTree : Observable<CategoriesTree> = null;
    
    public unchanged_since : Date;
    public cachedUnchanged_since : Observable<Date> = null;

    public url_base_img : string = '';
    
    // ACTUALMENT ES PASSA I CALCULA A PRODUCTLISTCOMPONENT JA QUE ES NECESSITA AL USERBAR, PERO SERIA MES ADIENT GESTIONAR ELS FILTRES AL CATALEG ?
    public currentCategory : Category = null;
    public filtered : boolean = false; 
    public sorted : boolean = false;
    
    private brands : Filter[] = [];
    private characteristics : Filter[]  = [];
    private offers : Filter[]  = [];
    private tipologies : Filter[]  = [];
    
    public get hasFilters() : boolean {
        return this.brands.length > 0 || this.characteristics.length > 0 || this.offers.length > 0 || this.tipologies.length > 0 ;
    }

    public get Brands () : Filter[] {
        return this.brands.sort( this.filterSort  );
    }
    public get Characteristics() : Filter[] {
        return this.characteristics.sort( this.filterSort  );
    }
    public get Offers () : Filter[] {
        return this.offers.sort( this.filterSort  );
    }
    public get Tipologies () : Filter[] {
        return this.tipologies.sort( this.filterSort  );
    }
    
    public get Categories () : Category[] {
        return this.Tree.getLevel(0,1);          
    }

    public get Featured() :Category[] {
        return this.Tree.getLevel(1,1);     
    }

    constructor(
        private http: HttpClient,
        private translate : TranslateService,
        private utils : UtilsService,
        private toastr : ToastrService,
        private datePipe : DatePipe
    ) {
    }

    // getBrands(curentFilters : Map<string, string[]>) : Filter[]{
    //     let brands : Filter[] = [];
    //     const currentProducts : string = sessionStorage.getItem('currentProducts');
    //     let products : Product[] = JSON.parse(currentProducts)
    //     if (products){
    //         products = this.processArray(null,curentFilters,0,products.length,products);
    //         products.map(item => new Product(item)).forEach ((product : Product) => {
    //             let filter : Filter;
    //             filter = brands.find( f => f.name == product.brand_name );
    //             if (filter){
    //                 filter.count += 1;
    //             } else {
    //                 filter = new Filter(product.brand_name);
    //                 brands.push(filter);
    //             }
    //         });
    //     }

    //     return brands;
    // }

    // getCharacteristics(curentFilters : Map<string, string[]>) : Filter[]{
    //     let characteristics : Filter[] = [];
    //     const currentProducts : string = sessionStorage.getItem('currentProducts');
    //     let products : Product[] = JSON.parse(currentProducts)
    //     if (products){
    //         products = this.processArray(null,curentFilters,0,products.length,products);
    //         products.map(item => new Product(item)).forEach ((product : Product) => {
    //             product.characteristics.forEach(( characteristic : Characteristic ) => {
    //                 let filter : Filter;
    //                 filter = characteristics.find( f => f.name == characteristic.getText(this.translate.currentLang) );
    //                 if (filter){
    //                     filter.count += 1;
    //                 } else {
    //                     filter = new Filter(characteristic.getText(this.translate.currentLang));
    //                     characteristics.push(filter);
    //                 }
    //             });
    //         });
    //     }

    //     return characteristics;
    // }

    getHomeProducts(logedUser: boolean , start? : number , pageSize? : number ) : Observable<Product[]> {

        return this.get('Oferta', null,null,null,start,pageSize, false);
        
        // if (!logedUser){
        //     return this.get('Oferta', null,null,null,start,pageSize);
        // }
        // else {
        //     return this.get('TopList',null,null,null,start,pageSize);
        // }
    }

    get( category : string,  filters? : Map<string, string[]>, orderBy?: string, query?: string ,  start? : number , pageSize? : number, filtering? : boolean ) : Observable<Product[]> {

        if (query) {
            query = query.replace('\'',' ');
            this.searching = true;

            if (start == 0 && ! filtering) {
                return this.http.get<Product[]>(`${environment.API_ENDPOINT}search/languages/${this.translate.currentLang}/${query}/products`)
                .pipe(
                    delay(environment.FAKE_DELAY),
                    retryWhen ( errors  => {
                        return errors
                        .pipe(
                            switchMap( (error) => (error.status != 503) ? throwError(error) : of(error)),
                            // Use concat map to keep the errors in order and make sure they aren't executed in parallel
                            concatMap( (e, i) => 
                            // Executes a conditional Observable depending on the result of the first argument
                            iif(
                            () => i > environment.MAX_RETRY_COUNT,
                            // If the condition is true we throw the error (the last error)
                            throwError(e),
                            // Otherwise we pipe this back into our stream and delay the retry
                            of(e).pipe(delay(environment.RETRY_DELAY)) 
                            )
                        ));
                    }),
                    map( result => {                   
                        sessionStorage.setItem('currentProducts', JSON.stringify(result));
                        this.searching = false;
                        return this.processArray(orderBy, filters,  start, pageSize, result); 
                    }),
                    catchError(err => {
                        // this.toastr.warning(err.statusText + '->' + err.message);
                        this.searching = false;
                        return throwError (err);
                    }),
                    finalize(() => {}),
                );
            } else {
                this.searching = true;
                const currentProducts : string = sessionStorage.getItem('currentProducts');
                return of( this.processArray(orderBy, filters, start, pageSize, JSON.parse(currentProducts))).pipe(
                    delay(environment.FAKE_DELAY),
                    map ( result => {
                        this.searching = false;
                        return result;
                    }),
                );   
            }
        }

        if (category ){

            if (start == 0 && ! filtering){
                this.searching = true;
                return this.http.get<Product[]>(`${environment.API_ENDPOINT}products/category/${category}`).pipe( 
                    delay(environment.FAKE_DELAY),
                    retryWhen(errors => {
                        return errors.pipe(
                            switchMap( (error) => (error.status != 503) ? throwError(error) : of(error)),
                            // Use concat map to keep the errors in order and make sure they aren't executed in parallel
                            concatMap( (e, i) => 
                            // Executes a conditional Observable depending on the result of the first argument
                            iif(
                              () => i > environment.MAX_RETRY_COUNT,
                              // If the condition is true we throw the error (the last error)
                              throwError(e),
                              // Otherwise we pipe this back into our stream and delay the retry
                              of(e).pipe(delay(environment.RETRY_DELAY)) 
                            )
                          ));
                    }),
                    map( result => {
                        sessionStorage.setItem('currentProducts', JSON.stringify(result));
                        this.searching = false;
                        return this.processArray(orderBy, filters, start, pageSize, result); 
                    }),
                    catchError(err => {
                        // this.toastr.warning(err.statusText + '->' + err.message);
                        this.searching = false;
                        return throwError (err);
                    }),
                    finalize(() => {})
                );
            } else {
                this.searching = true;
                const currentProducts : string = sessionStorage.getItem('currentProducts');
                return of( this.processArray(orderBy, filters, start, pageSize, JSON.parse(currentProducts))).pipe(
                    delay(environment.FAKE_DELAY),
                    map ( result => {
                        this.searching = false;
                        return result;
                    }),
                );
            }
        } 

        return of([]).pipe(
            map ( result => {
                this.searching = false;
                return result;
            }),
        );
         

    }

    // getProduct( productId : string) : Observable<Product>{
       
    //     this.searching = true;
    //     return this.http.get<Product>(`${environment.API_ENDPOINT}search/itemid/${productId}`).pipe( 
    //         delay(environment.FAKE_DELAY),
    //         retryWhen(errors => {
    //             return errors.pipe(
    //                  switchMap( (error) => (error.status != 503) ? throwError(error) : of(error)),
    //                 // Use concat map to keep the errors in order and make sure they aren't executed in parallel
    //                 concatMap( (e, i) => 
    //                 // Executes a conditional Observable depending on the result of the first argument
    //                 iif(
    //                   () => i > environment.MAX_RETRY_COUNT,
    //                   // If the condition is true we throw the error (the last error)
    //                   throwError(e),
    //                   // Otherwise we pipe this back into our stream and delay the retry
    //                   of(e).pipe(delay(environment.RETRY_DELAY)) 
    //                 )
    //               )
    //             );
    //         }),
    //         map( result => {
    //             this.searching = false;
    //             return new Product(result); 
    //         }),
    //     );
    // }

    getProduct( productId : string , lang : string) : Observable<FileProduct>{
        this.searching = true;
        return this.http.get<FileDetails>(`${environment.API_ENDPOINT}productdetails/files/${productId}/${lang}`).pipe( 
            delay(environment.FAKE_DELAY),
            retryWhen(errors => {
                return errors.pipe(
                    switchMap( (error) => (error.status != 503) ? throwError(error) : of(error)),
                    // Use concat map to keep the errors in order and make sure they aren't executed in parallel
                    concatMap( (e, i) => 
                    // Executes a conditional Observable depending on the result of the first argument
                    iif(
                      () => i > environment.MAX_RETRY_COUNT,
                      // If the condition is true we throw the error (the last error)
                      throwError(e),
                      // Otherwise we pipe this back into our stream and delay the retry
                      of(e).pipe(delay(environment.RETRY_DELAY)) 
                    )
                    ));
                }),
                map( result => {
                    this.searching = false;
                    return new FileProduct(result); 
                }),
                catchError(err => {
                    // this.toastr.warning(err.statusText + '->' + err.message);
                    this.searching = false;
                    return throwError (err);
                }),
        );
    }

    getProductExtendedInfo( productId : string ,  extendedId : string, lang : string) : Observable<InfoExt>{
       this.searching = true;
        return this.http.get<InfoExt>(`${environment.API_ENDPOINT}infoext/${extendedId}/${productId}/${lang}`).pipe( 
            delay(environment.FAKE_DELAY),
            retryWhen(errors => {
                return errors.pipe(
                    switchMap( (error) => (error.status != 503) ? throwError(error) : of(error)),
                    // Use concat map to keep the errors in order and make sure they aren't executed in parallel
                    concatMap( (e, i) => 
                    // Executes a conditional Observable depending on the result of the first argument
                    iif(
                      () => i > environment.MAX_RETRY_COUNT,
                      // If the condition is true we throw the error (the last error)
                      throwError(e),
                      // Otherwise we pipe this back into our stream and delay the retry
                      of(e).pipe(delay(environment.RETRY_DELAY)) 
                    )
                    )
                );
            }),
            map( result => {
                this.searching = false;
                let extInfo : InfoExt;
                
                switch (extendedId) {
                    case 'APPvins':
                        extInfo = new InfoExt_Celler(result);
                        break;
                    default: 
                        extInfo = new InfoExt(result); 
                        break;
                };
                return extInfo;
            }),
            catchError(err => {
                // this.toastr.warning(err.statusText + '->' + err.message);
                return throwError (err);
            })
        );
    }
    


    public processArray(orderBy : string, filters : Map<string, string[]>, start : number , pageSize : number, products : Product[]) : Product[] {
        let processed : Product[];
        processed = products.map(item => new Product(item));
        
        // CALC NEW FILTERS
        this.characteristics = this.characteristics.slice(0,0);
        this.brands = this.brands.slice(0,0);
        this.offers = this.offers.slice(0,0);
        this.tipologies = this.tipologies.slice(0,0);

        processed.forEach ((product : Product) => {

            // BRAND
            let filter : Filter;
            filter = this.brands.find( f => f.name == product.brand_name );
            if (filter) {
                filter.count += 1;
            } else {
                if (product.brand_name != ''){
                    filter = new Filter(product.brand_name);
                    this.brands.push(filter);
                }
            }

            // CHARACTERISTIC
            product.characteristics.forEach(( characteristic : Characteristic ) => {
                let filter : Filter;
                filter = this.characteristics.find( f => f.name == characteristic.getText(this.translate.currentLang) );
                if (filter){
                    filter.count += 1;
                } else {
                    filter = new Filter(characteristic.getText(this.translate.currentLang));
                    this.characteristics.push(filter);
                }
            });

            // OFFERS
            filter = this.offers.find( f => f.name == product.getOfferText(this.translate.currentLang) );
            if (filter){
                filter.count += 1;
            } else {
                if (product.getOfferText(this.translate.currentLang) != ''){
                    filter = new Filter(product.getOfferText(this.translate.currentLang));
                    this.offers.push(filter);
                }
            }

            // TIPOLOGIES
            if (this.Tree){
                filter = this.tipologies.find( f => { 
                    let found : boolean = false;
                    let cat : Category;
                    cat = this.Tree.getCategory(product.filter_id);
                    if (cat){
                        found =  f.name == cat.getText(this.translate.currentLang);
                    }
                    return found;
                })

                if (filter){
                    filter.count += 1;
                } else {
                    let cat : Category = this.Tree.getCategory(product.filter_id);
                    if (cat) {
                        filter = new Filter(cat.getText(this.translate.currentLang));
                        this.tipologies.push(filter);
                    }
                }
            }

        });

        // APPLY  FILTERS
        if (filters){
            processed = processed.filter(item => {
                let filteredT : boolean = true;
                let filteredB : boolean = true;
                let filteredC : boolean = true;
                let filteredO : boolean = true;

                filteredT = filteredT && filters.get('TIPOLOGY').length == 0;
                filters.get('TIPOLOGY').forEach(filter => {
                    let cat = this.Tree.getCategory(item.filter_id)
                    if (cat){
                        filteredT = filteredT ||  cat.getText(this.translate.currentLang) === filter;
                    }
                });


                filteredB = filteredB && filters.get('BRAND').length == 0;
                filters.get('BRAND').forEach(filter => {
                    filteredB = filteredB || item.brand_name === filter;
                });

                filteredC = filteredC && filters.get('CHARACTERISTIC').length == 0;
                filters.get('CHARACTERISTIC').forEach(filter => {
                    item.characteristics.forEach(characteristic => {
                        filteredC = filteredC || characteristic.getText(this.translate.currentLang) === filter;
                    });
                });

                filteredO = filteredO && filters.get('OFFER').length == 0;
                filters.get('OFFER').forEach(filter => {
                    filteredO = filteredO || item.getOfferText(this.translate.currentLang) === filter;
                });

                return (filteredT && filteredB && filteredC && filteredO ) || (item.gift);
            });   
        }
        // SORT
        this.sorted = orderBy && orderBy !== '';
        if (this.sorted){
            processed = processed.sort( this.productSort(orderBy , this.translate.currentLang));
        }
        // INFINITE SCROLL
        let end : number =  Math.min(start + pageSize, processed.length) ;
        // console.log(`[${processed.length}] + ${pageSize} -> ${start} : ${end}`);
        processed = processed.slice(start , end);
        return processed;
    }

    public getTree (logedUser: boolean) : Observable<CategoriesTree> {
        let observable : Observable<CategoriesTree> = null;
       
        if (this.Tree && this.Tree.auth == logedUser ){
            observable = of(this.Tree);
        } else if (this.cachedTree) {
            observable = this.cachedTree;
        } else {
            this.loading = true;

            this.cachedTree = this.getUnchangedSince().pipe(
                concatMap (unchanged_since => {
                    let tree_unchanged_since : Date = null ;
                    let parts : string[];
            
                    // ultima fecha modificacion arbol session, si existe
                    const s_unchanged_since = sessionStorage.getItem('unchanged_since')
                    if ( s_unchanged_since ){
                        parts = s_unchanged_since.split("/"); 
                        tree_unchanged_since = new Date(parseInt(parts[2], 10), parseInt(parts[1], 10) - 1, parseInt(parts[0], 10));
                    }
                  
                    const sessionTree : string = sessionStorage.getItem('categoriesTree');
                    const sessionAuthTree : string = sessionStorage.getItem('categoriesAuthTree');
                    
                    if (! logedUser && sessionTree ){    

                        this.Tree = new CategoriesTree(JSON.parse(sessionTree));
                        this.url_base_img = environment.BASE_IMAGE_URL + this.Tree.url_base_img;
            
                        if ( tree_unchanged_since && tree_unchanged_since >= unchanged_since){
                            this.Tree.auth = false;
                            this.loading = false;
                            return of(this.Tree);
                        } else {
                            this.Tree = null;
                        }
                    }

                    if (logedUser && sessionAuthTree ){

                        this.Tree = new CategoriesTree(JSON.parse(sessionAuthTree));
                        this.url_base_img = environment.BASE_IMAGE_URL + this.Tree.url_base_img;
            
                        if ( tree_unchanged_since && tree_unchanged_since >= unchanged_since){
                            this.Tree.auth = true;
                            this.loading = false;
                            return of(this.Tree);
                        } else {
                            this.Tree = null;
                        }
                    }    

                    return this.getTreeDate(logedUser, unchanged_since);

                }),
                share(),
                finalize(() => this.cachedTree = null)
            );

            observable = this.cachedTree;
        }
        return observable;
    }

    private getUnchangedSince() : Observable<Date> {
        // ultima fecha modificacion arbol (WS)
        let observable : Observable<Date>;
        if (this.unchanged_since){
            observable = of(this.unchanged_since);
        } else if (this.cachedUnchanged_since){
            observable = this.cachedUnchanged_since;
        } else {
            this.cachedUnchanged_since = this.http.get<any>(`${environment.API_ENDPOINT}categories/newest`).pipe(
                map( newest =>{
                   let parts : string[];
                    parts = newest.unchanged_since.split("/");
                    return  new Date(parseInt(parts[2], 10), parseInt(parts[1], 10) - 1, parseInt(parts[0], 10));
                }),
                share(),
                catchError(err => {
                    return of(new Date());
                }),
                finalize(() => this.cachedUnchanged_since = null)
            );
           observable = this.cachedUnchanged_since;
        }
        
        return observable;

    }

    private getTreeDate (logedUser : boolean, unchanged_since : Date) : Observable<CategoriesTree>{
        return this.http.get<CategoriesTree>(`${environment.API_ENDPOINT}categories/tree`).pipe(
            tap ( result =>{
                this.Tree = new CategoriesTree(result);
                this.Tree.auth = logedUser;

                sessionStorage.setItem('unchanged_since', this.datePipe.transform(unchanged_since, 'dd/MM/yyyy'));

                if (logedUser) {
                    sessionStorage.setItem('categoriesAuthTree', JSON.stringify(result));
                } else {
                    sessionStorage.setItem('categoriesTree', JSON.stringify(result));
                }
                this.url_base_img = environment.BASE_IMAGE_URL +  this.Tree.url_base_img;
                this.loading = false;                           
            }),
            retryWhen(errors => {
                return errors.pipe(
                    switchMap( (error) => (error.status != 503) ? throwError(error) : of(error)),
                    // Use concat map to keep the errors in order and make sure they aren't executed in parallel
                    concatMap( (e, i) => 
                    // Executes a conditional Observable depending on the result of the first argument
                    iif(
                    () => i > environment.MAX_RETRY_COUNT,
                    // If the condition is true we throw the error (the last error)
                    throwError(e),
                    // Otherwise we pipe this back into our stream and delay the retry
                    of(e).pipe(delay(environment.RETRY_DELAY)) 
                    )
                ));
            }),
            catchError(err => {
                // this.toastr.warning(err.statusText + '->' + err.message);
                return throwError (err);
            }),
            finalize(()=>{
                this.loading = false;
            })
        )
    }
    
    private filterSort (a: Filter, b: Filter) : number {
        // Ordre per quantitat
        //return b.count - a.count;
        // Ordre alfabetic
        return  a.name.localeCompare(b.name);
    }

    private productSort(orderBy : string, lang: string)  {

        return function(a : Product, b : Product) {
           
            // Si el producte surt gratuït, sepmre el primer.
            if (a.gift){
                return -1;
            }
            if (b.gift){
                return 1;
            }
            switch (orderBy){
                case 'ALF_ASC':
                    return  a.getText(lang).localeCompare(b.getText(lang));
                    break ;
                case 'ALF_DESC':
                    return b.getText(lang).localeCompare(a.getText(lang));
                    break ;
                case 'CHE':
                    return a.price - b.price;
                    break;
                case 'EXP':
                    return b.price - a.price;
                    break;
                default: 
                    return a.id.localeCompare(b.id);
            }
            
        }
    }

    public getCategory (categoryId : string) :Observable<Category> {
        return this.http.get<any>(`${environment.API_ENDPOINT}categories/tree/${categoryId}`).pipe(
            map(result =>{
                return new Category(result.category,this.Tree.category);
            })
        );
    }

    //20250602 axa inici
    public clearCache() {
      this.Tree = null;
    }
    //20250602 axa final

}
